var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31257_3103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 32H26V62H54V32Z",
    fill: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 58H42V36H50V58Z",
    fill: "url(#paint0_linear_31257_3103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 58H30L30 36H38V58Z",
    fill: "url(#paint1_linear_31257_3103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0104 32C21.938 30.1874 22.244 28.3793 22.9098 26.684C23.5757 24.9887 24.5878 23.4411 25.8856 22.1339C27.1834 20.8267 28.74 19.7868 30.4624 19.0765C32.1847 18.3661 34.0373 18 35.9091 18C37.781 18 39.6335 18.3661 41.3559 19.0765C43.0782 19.7868 44.6349 20.8267 45.9327 22.1339C47.2304 23.4411 48.2425 24.9887 48.9084 26.684C49.5743 28.3793 49.8802 30.1874 49.8079 32",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2727 18H35.0908V32H43.2727V18Z",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5559 32C28.4793 30.1874 28.8032 28.3793 29.5083 26.684C30.2133 24.9887 31.285 23.4411 32.6591 22.1339C34.0332 20.8267 35.6814 19.7868 37.5051 19.0765C39.3287 18.3661 41.2903 18 43.2722 18C45.2542 18 47.2157 18.3661 49.0394 19.0765C50.863 19.7868 52.5113 20.8267 53.8854 22.1339C55.2595 23.4411 56.3311 24.9887 57.0362 26.684C57.7412 28.3793 58.0652 30.1874 57.9885 32",
    fill: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 32H22V36H58V32Z",
    fill: "#8E8CEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31257_3103",
    x1: 46,
    y1: 43.8571,
    x2: 56.0104,
    y2: 67.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31257_3103",
    x1: 34.5714,
    y1: 47.7857,
    x2: 43.4995,
    y2: 67.2651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31257_3103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/Door.a08fc999e7d9fdbc89b3958798165dbd.svg";
export { ForwardRef as ReactComponent };